module.exports = __webpack_public_path__ + "static/media/IMG_5c.d60eb1d0.jpg";